export enum LeftNavigationTab {
	None,
	Inbox,
	Prompt,
	FavoriteArticles,
}
